/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum reportTypeEnum {
    EXECUTIVE = 'executive',
    TOPLINE = 'topline',
    GRAPH = 'graph',
    VERBATIM = 'verbatim',
}